import { supabase } from '@/lib/supabase'

const KEY_COOLDOWN = 'ops.webpush_cooldown_ms'
const KEY_AGGREGATE = 'ops.webpush_aggregate'
const KEY_AGGREGATE_MIN = 'ops.webpush_aggregate_min_count'
const KEY_NOTIFY_GUARD = 'ops.webpush_notify_guard_sec'

export type PushPolicy = { aggregate: boolean; cooldownMs: number; aggregateMin: number; notifyGuardSec: number }

export async function getPushPolicy(): Promise<PushPolicy> {
  const { data: rows, error } = await supabase
    .from('app_settings')
    .select('key, value')
    .in('key', [KEY_COOLDOWN, KEY_AGGREGATE, KEY_AGGREGATE_MIN, KEY_NOTIFY_GUARD])
  if (error) throw error
  const map = new Map<string, string>((rows || []).map((r: any) => [r.key, String(r.value)]))
  const cooldownMs = parseInt(map.get(KEY_COOLDOWN) || '60000', 10)
  const aggregate = (map.get(KEY_AGGREGATE) || 'true') === 'true'
  const aggregateMin = Math.max(1, parseInt(map.get(KEY_AGGREGATE_MIN) || '3', 10))
  const notifyGuardSec = Math.max(0, parseInt(map.get(KEY_NOTIFY_GUARD) || '60', 10))
  return { aggregate, cooldownMs: Number.isFinite(cooldownMs) ? cooldownMs : 60000, aggregateMin, notifyGuardSec }
}

export async function setPushPolicy(policy: PushPolicy): Promise<void> {
  const rows = [
    { key: KEY_COOLDOWN, value: String(Math.max(0, Math.round(policy.cooldownMs))) },
    { key: KEY_AGGREGATE, value: policy.aggregate ? 'true' : 'false' },
    { key: KEY_AGGREGATE_MIN, value: String(Math.max(1, Math.round(policy.aggregateMin))) },
    { key: KEY_NOTIFY_GUARD, value: String(Math.max(0, Math.round(policy.notifyGuardSec))) },
  ]
  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}
